import React from 'react'
import style from "./MiddleOne.module.css"

const SingleForUnderfourNine = (el) => {
  return (
    <div className={style.SingleForUnderfourNine}>
        <img src={el.thumbnail} alt="Not-Found" />
    </div>
  )
}

export default SingleForUnderfourNine